import {BaseError} from './base-error';

/**
 * Class representing an API error.
 * @extends Error
 */
export class ApiError extends BaseError {
  body: any;

  endPoint: any;

  status: any;

  /**
   * @param {object} params - Parameters
   * @param {number} params.status - response status
   * @param {string} params.endPoint - the endpoint we are referring to
   * @param {string} params.body - response body
   */
  constructor({status, endPoint, body}: any = {}) {
    const error = `"${endPoint}" has responded with ${status} and body "${body}"`;

    super({name: 'APIError', error});

    this.status = status;
    this.endPoint = endPoint;
    this.body = body;
  }
}
